var map = {
	"./Abhilash.jpg": 5152,
	"./Abhilash_B.jpg": 39391,
	"./Abhinav.jpg": 90581,
	"./Akhil.jpg": 8882,
	"./Akshitha.jpeg": 99364,
	"./Anand.jpg": 55882,
	"./Anirudh.jpeg": 61832,
	"./Anvitha.jpg": 71165,
	"./Avighna.jpeg": 8415,
	"./Bhanu.jpg": 64494,
	"./Dhanush.JPG": 86492,
	"./Harshini.jpg": 68166,
	"./Nithin.jpeg": 28035,
	"./Renuka.jpg": 10300,
	"./Ronak.jpg": 22531,
	"./Sai_Manish.jpg": 35740,
	"./Samhith.jpeg": 57619,
	"./SamplePPTWebathon3.0.pptx": 42655,
	"./Sanjana.jpeg": 21825,
	"./Shivalini.jpg": 20489,
	"./Shravani.jpg": 4430,
	"./Siddartha.jpg": 56444,
	"./Sravani.jpeg": 24303,
	"./TkinterWorkingAll (2).zip": 82293,
	"./Vamshi.jpg": 26754,
	"./Varshitha.jpeg": 90587
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76422;